import React, { Component } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { connect } from "react-redux";

import ZoomableCarousel from "./ZoomableCarousel";
import FavoriteProductIcon from "./FavoriteProducts/FavoriteProductIcon";

class ProductCarousel extends Component {
  carouselRef = React.createRef();
  mainImageRef = React.createRef();
  state = { carouselWidth: null, mainImageHeight: 300 };
  setCarouselWidth = () => {
    if (this.carouselRef.current) {
      this.setState({ carouselWidth: this.carouselRef.current.clientWidth });
    }
  };

  componentDidMount() {
    this.setCarouselWidth();
    window.addEventListener("resize", this.setCarouselWidth);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.setCarouselWidth);
  }

  render() {
    let images = [];
    const { current_product } = this.props;
    const { carouselWidth } = this.state;
    const hasThumbs = current_product
      ? current_product.photo_thumb &&
        current_product.photo_small &&
        current_product.photo_medium
      : null;
    images.push(
      <div key={`photo${0}`}>
        <img
          className="preventDrag"
          src={current_product.photo}
          srcSet={
            hasThumbs
              ? `${current_product.photo_thumb} 120w, ${current_product.photo_small} 300w, ${current_product.photo_medium} 800w`
              : null
          }
          style={{
            height: this.state.mainImageHeight,
            backgroundColor: "white",
            objectFit: current_product.stretch_photo ? "cover" : "contain",
            width: "100%",
          }}
          ref={this.mainImageRef}
          onLoad={() => {
            this.setState({
              mainImageHeight:
                Math.max(
                  Math.min(
                    (this.mainImageRef.current.naturalHeight /
                      this.mainImageRef.current.naturalWidth) *
                      this.mainImageRef.current.width,
                    550
                  ),
                  230
                ) || 350,
            });
          }} // print 150
        />
      </div>
    );
    this.props.current_product.gallery
      .sort((a, b) => a.sort_order - b.sort_order)
      .forEach((photo, i) =>
        images.push(
          <div key={`photo${i + 1}`} className="my-auto">
            <img
              className="preventDrag"
              src={photo.photo_medium || photo.photo}
              style={{
                height: this.state.mainImageHeight,
                backgroundColor: "white",
                objectFit: this.props.current_product.stretch_photo
                  ? "cover"
                  : "contain",
                width: "100%",
              }}
            />
          </div>
        )
      );
    if (!images.length) {
      images = [
        <div key="Main Photo">
          <img
            src={this.props.current_product.photo}
            style={{ height: this.state.mainImageHeight, objectFit: "cover" }}
          />
        </div>,
      ];
    }

    return (
      <div
        className=" mt-5"
        ref={this.carouselRef}
        style={{ position: "relative" }}
      >
        {this.props.auth.user &&
          this.props.settings.user_favorite_product &&
          this.props.settings.user_favorite_product_staff && (
            <div
              className="discount-sign"
              style={{
                right: 10,
                direction: this.props.language !== "arabic" && "ltr",
                zIndex: 100,
                top: images.length > 1 ? "75%" : "87%",
              }}
            >
              <FavoriteProductIcon productId={current_product.id} />
            </div>
          )}
        {carouselWidth && (
          <ZoomableCarousel
            height={this.state.mainImageHeight}
            initialSlide={0}
            slides={images}
            carouselWidth={carouselWidth}
            language={this.props.language}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    current_product: state.store.current_product,
    auth: state.auth,
    settings: state.store.store.settings,
  };
};

export default connect(mapStateToProps)(ProductCarousel);
